export const TextTypes = {
    SET_TEXT_DATA: 'SET_TEXT_DATA'
};  